import styled, { keyframes } from 'styled-components'

import { helpers } from 'styles'

const dash = keyframes`
	0% {
		stroke-dashoffset: 10;
		transform: rotate(-180deg);
	}

	60% {
		stroke-dashoffset: 30;
	}

	100% {
		stroke-dashoffset: 10;
		transform: rotate(180deg);
	}
`

export const SecondaryCircle = styled.circle`
	animation: 0.8s linear infinite both ${dash};
	fill: transparent;
	stroke: ${helpers.color.spinnerSecondary};
	stroke-dasharray: 100;
	stroke-linecap: round;
	transform-origin: 50% 50%;
`
